// extracted by mini-css-extract-plugin
module.exports = {"priceAndDiscount":"style_priceAndDiscount__mnsOu","icon":"style_icon__23l9C"};